export const closeHeaderMenu = () => {
	document.addEventListener('click', (e) => {
		if (e.target.closest('.header-menu__item')) {
			document.querySelector('.header-menu').classList.remove('active');
		}
	});
};
